import Storefront from 'utils/storefront';

export default async function checkInventoryAvailable(variantId, requestedQuantity, cart, currentLineKey) {
  const currentLine = cart?.state?.items?.find(item => item.key === currentLineKey);
  
  // Skip check if:
  // 1. Not tracked (inventoryManagement !== 'shopify') OR
  // 2. Tracked but allows overselling (inventoryPolicy === 'continue')
  if (currentLine?.properties?._inventoryManagement !== 'shopify' || 
      currentLine?.properties?._inventoryPolicy === 'continue') {
    return {
      available: true,
      maxQuantity: Infinity
    };
  }

  const storefront = new Storefront();

  // Get total quantity of this variant in cart (excluding current line)
  let totalInCart = 0;
  cart?.state?.items?.forEach((item) => {
    if (item.properties?._bundleProductsId) {
      return;
    }

    const lineVariantId = String(item.variant_id);
    const compareVariantId = String(variantId);

    if (lineVariantId === compareVariantId && item.key !== currentLineKey) {
      totalInCart += item.quantity;
    }
  });

  const formattedVariantId = String(variantId).includes('gid://')
    ? variantId
    : `gid://shopify/ProductVariant/${variantId}`;

  try {
    const response = await storefront.request({
      query: `
        query checkVariantInventory($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              quantityAvailable
            }
          }
        }
      `,
      variables: {
        id: formattedVariantId,
      },
    });

    const quantityAvailable = response?.data?.node?.quantityAvailable ?? Infinity;
    const totalRequested = totalInCart + requestedQuantity;

    return {
      available: totalRequested <= quantityAvailable,
      maxQuantity: Math.max(0, quantityAvailable - totalInCart),
    };
  } catch (error) {
    return {
      available: true,
      maxQuantity: Infinity,
    };
  }
}
